import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "golf-financial-report-page" }
const _hoisted_2 = { class: "report-header" }
const _hoisted_3 = { class: "summary-cards" }
const _hoisted_4 = { class: "stat-card border-orange" }
const _hoisted_5 = { class: "stat-header" }
const _hoisted_6 = { class: "stat-label" }
const _hoisted_7 = { class: "stat-amount" }
const _hoisted_8 = { class: "stat-sub" }
const _hoisted_9 = { class: "stat-card border-orange" }
const _hoisted_10 = { class: "stat-header" }
const _hoisted_11 = { class: "stat-label" }
const _hoisted_12 = { class: "stat-amount" }
const _hoisted_13 = { class: "stat-sub" }
const _hoisted_14 = { class: "stat-card border-orange" }
const _hoisted_15 = { class: "stat-header" }
const _hoisted_16 = { class: "stat-label" }
const _hoisted_17 = { class: "stat-amount" }
const _hoisted_18 = { class: "transactions-section" }
const _hoisted_19 = { class: "section-header" }
const _hoisted_20 = { class: "section-title" }
const _hoisted_21 = ["onDragstart", "onDrop", "onClick"]
const _hoisted_22 = {
  key: 0,
  class: "renter-cell"
}
const _hoisted_23 = { class: "renter-info" }
const _hoisted_24 = { class: "renter-name" }
const _hoisted_25 = { class: "renter-phone" }
const _hoisted_26 = {
  key: 1,
  class: "payment-badge"
}
const _hoisted_27 = {
  key: 2,
  class: "rental-fee-text"
}
const _hoisted_28 = {
  key: 5,
  class: "timestamp-text"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "pagination-container" }
const _hoisted_31 = { class: "pagination-info" }

import { ref, computed, onMounted, watch } from 'vue'
import {
  Download,
  ArrowDown,
  ArrowUp
} from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { useGolfTripsStore } from '@/store/golf-trips'
import { useGolfFinancialStore } from '@/store/golf-financial'
import { useGolfI18n } from '@/composables/useGolfI18n'
import { extractErrorMessage } from '@/helpers/error-parsers'
import type { GolfTrip } from '@/api/golf'
import { routeNames } from '@/router/route-names'
import { useRouter } from 'vue-router'
import { useGolfHeaderStore } from '@/store/golf-header'

const pageSize = 12


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const golfStore = useGolfTripsStore()
const financialStore = useGolfFinancialStore()
const headerStore = useGolfHeaderStore()
const { t } = useGolfI18n()

const defaultColumns = [
  { id: 'renter_name', label: 'golf.financial.col_renter', minWidth: '180', align: 'left' },
  { id: 'payment_method', label: 'golf.trips.payment_method', minWidth: '180', align: 'center' },
  { id: 'rental_fee', label: 'golf.financial.col_rental_fee', minWidth: '140', align: 'center' },
  { id: 'outstanding', label: 'golf.financial.col_outstanding', minWidth: '140', align: 'center' },
  { id: 'deposit_status', label: 'golf.financial.col_deposit_status', minWidth: '210', align: 'left' },
  { id: 'timestamp', label: 'golf.financial.col_timestamp', minWidth: '160', align: 'left' },
  { id: 'action', label: 'golf.fleet.actions', minWidth: '150', align: 'left' }
]

const activeColumns = ref(defaultColumns.map(c => ({ ...c, visible: true })))
const draggedColumnId = ref<string | null>(null)

const handleDragStart = (id: string) => {
  draggedColumnId.value = id
}

const handleDrop = (id: string) => {
  if (draggedColumnId.value && draggedColumnId.value !== id) {
    const fromIndex = activeColumns.value.findIndex(c => c.id === draggedColumnId.value)
    const toIndex = activeColumns.value.findIndex(c => c.id === id)
    if (fromIndex !== -1 && toIndex !== -1) {
      const item = activeColumns.value.splice(fromIndex, 1)[0]
      activeColumns.value.splice(toIndex, 0, item)
      tableKey.value++
    }
  }
  draggedColumnId.value = null
}

const tableKey = ref(0)
const activeTab = ref('all')

const timeRange = ref('all_time')
const searchQuery = computed({
  get: () => headerStore.searchQuery,
  set: (val) => headerStore.setSearchQuery(val)
})
const currentPage = ref(1)
const sortProp = ref('')
const sortOrder = ref('descending')

const toggleSort = (prop: string) => {
  if (sortProp.value === prop) {
    sortOrder.value = sortOrder.value === 'descending' ? 'ascending' : 'descending'
  } else {
    sortProp.value = prop
    sortOrder.value = 'ascending'
  }
}

const maskRenterPhone = (phone: string | undefined | null) => {
  if (!phone || phone === '—') return '—'
  const digits = phone.replace(/\D/g, '')
  const last2 = digits.slice(-2)
  const prefix = phone.startsWith('+')
    ? phone.slice(0, Math.min(4, phone.length - 2))
    : `+${digits.slice(0, 3)}`
  return `${prefix} ***-***-${last2}`
}

const getDateRangeParams = (range: string): { date_from?: string; date_to?: string } => {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth()

  const formatYMD = (d: Date) => {
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
  }

  if (range === 'this_month') {
    const start = new Date(year, month, 1)
    const end = new Date(year, month + 1, 0)
    return {
      date_from: formatYMD(start),
      date_to: formatYMD(end),
    }
  } else if (range === 'last_month') {
    const start = new Date(year, month - 1, 1)
    const end = new Date(year, month, 0)
    return {
      date_from: formatYMD(start),
      date_to: formatYMD(end),
    }
  } else if (range === 'this_year') {
    const start = new Date(year, 0, 1)
    const end = new Date(year, 11, 31)
    return {
      date_from: formatYMD(start),
      date_to: formatYMD(end),
    }
  }
  return {}
}

const loadData = async () => {
  const params = getDateRangeParams(timeRange.value)
  await Promise.all([
    financialStore.fetchFinancialReport(params),
    golfStore.fetchTrips(),
  ])
}

onMounted(() => {
  headerStore.setHeaderInfo('golf.financial.title', true, 'golf.header.search_placeholder')
  loadData()
})

watch(timeRange, () => {
  currentPage.value = 1
  loadData()
})

const getRenter = (trip: GolfTrip) => {
  return trip.renter
}

const formatRenterName = (trip: GolfTrip) => {
  const user = getRenter(trip)
  if (user?.first_name && user?.last_name) {
    return `${user.first_name} ${user.last_name[0]}.`
  }
  return user?.name || trip.user_id
}

const formatDate = (dateStr?: string) => {
  if (!dateStr) return '—'
  const d = new Date(dateStr)
  const date = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  const time = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })
  return `${date} ${time}`
}

const getDepositStatus = (trip: any) => {
  const isFinished = ['completed', 'cancelled_by_user', 'cancelled_by_admin', 'cancelled_by_system', 'declined'].includes(trip.status)
  if (trip.payment) {
    if (trip.payment.deposit_refunded_amount && trip.payment.deposit_refunded_amount > 0) return 'RELEASED'
    if (trip.payment.deposit_charged_amount && trip.payment.deposit_charged_amount > 0) return 'CHARGED'
    if (trip.payment.deposit_frozen_amount && trip.payment.deposit_frozen_amount > 0) return 'HELD'
    if (trip.payment_method === 'cash') {
      return isFinished ? 'RELEASED' : 'PENDING'
    }
  }
  return isFinished ? 'RELEASED' : 'HELD'
}

const allTransactions = computed(() => {
  const reportTrips = financialStore.reportData?.trips
  const isUsingReportTrips = Array.isArray(reportTrips) && reportTrips.length > 0
  const trips = isUsingReportTrips ? reportTrips : (Array.isArray(golfStore.trips) ? golfStore.trips : [])

  return trips
    .filter(trip => {
      if (isUsingReportTrips) {
        return true
      }
      // Exclude cancelled/declined/pending trips that have NO charged revenue
      if (['cancelled_by_user', 'cancelled_by_admin', 'cancelled_by_system', 'declined'].includes(trip.status)) {
        const hasPayment =
          Number(trip.payment?.service_charged_amount || trip.payment?.charge_amount || 0) > 0 ||
          Number(trip.payment?.deposit_charged_amount || 0) > 0
        return hasPayment
      }
      return true
    })
    .map(trip => {
      const rawDate = trip.created_at || (trip as any).createdAt
      const deposit = Number(trip.deposit_amount) || 0
      const total = Number(trip.total_amount) || 0
      const baseRate = Number(trip.base_rate_amount) || Math.max(0, total - deposit)
      const discount = Number(trip.discount_amount) || 0
      const serviceCharged = Number(trip.payment?.service_charged_amount || 0)
      const chargeAmt = Number(trip.payment?.charge_amount || 0)
      const depCharged = Number(trip.payment?.deposit_charged_amount || 0)

      let rentalFee = 0
      if (serviceCharged > 0) {
        rentalFee = serviceCharged
      } else if (chargeAmt > depCharged) {
        rentalFee = chargeAmt - depCharged
      } else if (trip.status === 'completed') {
        rentalFee = Math.max(0, (total > 0 ? (total - deposit) : baseRate) - discount)
      } else {
        rentalFee = Math.max(0, baseRate - discount)
      }

      const isCancelled = ['cancelled_by_user', 'cancelled_by_admin', 'cancelled_by_system', 'declined'].includes(trip.status)
      const isCompleted = trip.status === 'completed'
      const isPaymentCharged = ['charged', 'completed'].includes(trip.payment?.payment_status?.toLowerCase() || '')

      let outstanding = 0
      if (isCancelled || isCompleted || isPaymentCharged || (serviceCharged > 0 && serviceCharged >= rentalFee)) {
        outstanding = 0
      } else {
        outstanding = Math.max(0, rentalFee - serviceCharged)
      }

      return {
        id: trip.id,
        renter_name: formatRenterName(trip),
        renter_phone: trip.renter?.phone || '—',
        payment_method: (trip.payment_method || 'card').toUpperCase(),
        rental_fee: rentalFee,
        outstanding: outstanding,
        deposit_amount: deposit,
        deposit_status: getDepositStatus(trip),
        timestamp: formatDate(rawDate),
        raw_trip: trip
      }
    })
    .sort((a, b) => {
      const timeA = a.raw_trip.created_at || (a.raw_trip as any).createdAt
      const timeB = b.raw_trip.created_at || (b.raw_trip as any).createdAt
      return (timeB ? new Date(timeB).getTime() : 0) - (timeA ? new Date(timeA).getTime() : 0)
    })
})

const filteredTransactions = computed(() => {
  let list = [...allTransactions.value]

  const isUsingReportTrips =
    Array.isArray(financialStore.reportData?.trips) &&
    financialStore.reportData!.trips.length > 0

  if (!isUsingReportTrips && timeRange.value && timeRange.value !== 'all_time') {
    const now = new Date()
    const currentYear = now.getFullYear()
    const currentMonth = now.getMonth()

    list = list.filter(t => {
      const tripDate = t.raw_trip.created_at || (t.raw_trip as any).createdAt
      if (!tripDate) return false
      const d = new Date(tripDate)

      if (timeRange.value === 'this_month') {
        return d.getFullYear() === currentYear && d.getMonth() === currentMonth
      } else if (timeRange.value === 'last_month') {
        const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1
        const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear
        return d.getFullYear() === lastMonthYear && d.getMonth() === lastMonth
      } else if (timeRange.value === 'this_year') {
        return d.getFullYear() === currentYear
      }
      return true
    })
  }

  if (activeTab.value === 'card') {
    list = list.filter(t => t.payment_method === 'CARD')
  } else if (activeTab.value === 'cash') {
    list = list.filter(t => t.payment_method === 'CASH')
  }

  const query = searchQuery.value.trim().toLowerCase()
  if (query) {
    list = list.filter(t =>
      t.id.toLowerCase().includes(query) ||
      t.renter_name?.toLowerCase().includes(query) ||
      t.renter_phone?.toLowerCase().includes(query)
    )
  }

  if (sortProp.value && sortOrder.value) {
    list.sort((a: any, b: any) => {
      let valA = a[sortProp.value]
      let valB = b[sortProp.value]

      if (sortProp.value === 'timestamp') {
        valA = new Date(a.raw_trip.created_at).getTime()
        valB = new Date(b.raw_trip.created_at).getTime()
      } else if (sortProp.value === 'renter_name') {
        valA = a.renter_name?.toLowerCase() || ''
        valB = b.renter_name?.toLowerCase() || ''
      }

      if (valA < valB) return sortOrder.value === 'ascending' ? -1 : 1
      if (valA > valB) return sortOrder.value === 'ascending' ? 1 : -1
      return 0
    })
  }

  return list
})

const totalCashRevenue = computed(() => {
  if (financialStore.summary?.cashRevenue !== undefined) {
    return Number(financialStore.summary.cashRevenue)
  }
  return filteredTransactions.value
    .filter(t => t.payment_method === 'CASH')
    .reduce((sum, t) => sum + t.rental_fee, 0)
})

const totalCreditRevenue = computed(() => {
  if (financialStore.summary?.cardRevenue !== undefined) {
    return Number(financialStore.summary.cardRevenue)
  }
  return filteredTransactions.value
    .filter(t => t.payment_method === 'CARD')
    .reduce((sum, t) => sum + t.rental_fee, 0)
})

const totalCustomerSavings = computed(() => {
  if (financialStore.summary?.totalDiscounts !== undefined) {
    return Number(financialStore.summary.totalDiscounts)
  }
  return filteredTransactions.value
    .reduce((sum, t) => sum + (t.raw_trip.discount_amount || 0), 0)
})

const paginatedTransactions = computed(() => {
  const start = (currentPage.value - 1) * pageSize
  return filteredTransactions.value.slice(start, start + pageSize)
})

const viewDetails = (tripId: string) => {
  router.push({ name: routeNames.golfTripDetails, params: { id: tripId } })
}

const exportReport = async () => {
  try {
    ElMessage.info(t('golf.financial.exporting_report') || 'Exporting Financial Report...')
    const params = getDateRangeParams(timeRange.value)
    await financialStore.exportFinancialReport(params)
    ElMessage.success('Export completed successfully')
  } catch (err: any) {
    ElMessage.error(extractErrorMessage(err, 'Failed to export financial report'))
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        modelValue: timeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
        placeholder: _ctx.$t('golf.financial.select_range'),
        class: "time-range-select",
        "popper-class": "time-range-dropdown"
      }, {
        prefix: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            src: "/icons_golf_module/Financial calendar.svg",
            alt: "calendar",
            class: "calendar-icon"
          }, null, -1)
        ])),
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: _ctx.$t('golf.financial.all_time'),
            value: "all_time"
          }, null, 8, ["label"]),
          _createVNode(_component_el_option, {
            label: _ctx.$t('golf.financial.this_month'),
            value: "this_month"
          }, null, 8, ["label"]),
          _createVNode(_component_el_option, {
            label: _ctx.$t('golf.financial.last_month'),
            value: "last_month"
          }, null, 8, ["label"]),
          _createVNode(_component_el_option, {
            label: _ctx.$t('golf.financial.this_year'),
            value: "this_year"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"]),
      _createVNode(_component_el_button, {
        type: "warning",
        class: "export-btn",
        size: "large",
        loading: _unref(financialStore).isLoading,
        onClick: exportReport
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { class: "btn-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Download))
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('golf.financial.export_financial_report')), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('golf.financial.total_revenue')), 1),
          _cache[5] || (_cache[5] = _createElementVNode("img", {
            src: "/icons_golf_module/Financial reports Total Revenue Cash.svg",
            alt: "Revenue Cash",
            class: "stat-icon-img",
            style: {"width":"24px","height":"24px"}
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_7, "₼ " + _toDisplayString(totalCashRevenue.value.toFixed(2)), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('golf.trips.cash')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('golf.financial.total_revenue')), 1),
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            src: "/icons_golf_module/Financial reports Total Revenue Credit.svg",
            alt: "Revenue Credit",
            class: "stat-icon-img",
            style: {"width":"24px","height":"24px"}
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_12, "₼ " + _toDisplayString(totalCreditRevenue.value.toFixed(2)), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('golf.trips.credit')), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('golf.promo.customer_savings')), 1),
          _cache[7] || (_cache[7] = _createElementVNode("img", {
            src: "/icons_golf_module/Financial reports Total Customer Saving.svg",
            alt: "Savings",
            class: "stat-icon-img",
            style: {"width":"24px","height":"24px"}
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_17, "₼ " + _toDisplayString(totalCustomerSavings.value.toFixed(2)), 1),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "stat-sub" }, " ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t('golf.financial.recent_transactions')), 1)
      ]),
      (_openBlock(), _createBlock(_component_el_table, {
        key: tableKey.value,
        data: paginatedTransactions.value,
        class: "transactions-table"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeColumns.value.filter(c => c.visible), (col) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: col.id,
              "min-width": col.minWidth,
              prop: col.id,
              align: col.align || 'left'
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", {
                  draggable: "true",
                  onDragstart: ($event: any) => (handleDragStart(col.id)),
                  onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                  onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: ($event: any) => (handleDrop(col.id)),
                  onClick: ($event: any) => (col.id !== 'action' ? toggleSort(col.id) : null),
                  style: _normalizeStyle({
                  cursor: 'grab',
                  whiteSpace: 'nowrap',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent:
                    col.align === 'center' ? 'center' : 'flex-start',
                  width: '100%',
                  userSelect: 'none',
                })
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t(col.label)) + " ", 1),
                  (col.id !== 'action')
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        style: {"margin-left":"4px","font-size":"10px"}
                      }, {
                        default: _withCtx(() => [
                          (
                      sortProp.value === col.id && sortOrder.value === 'ascending'
                    )
                            ? (_openBlock(), _createBlock(_unref(ArrowUp), { key: 0 }))
                            : (_openBlock(), _createBlock(_unref(ArrowDown), { key: 1 }))
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 44, _hoisted_21)
              ]),
              default: _withCtx(({ row }) => [
                (col.id === 'renter_name')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(row.renter_name), 1),
                        _createElementVNode("div", _hoisted_25, _toDisplayString(maskRenterPhone(row.renter_phone)), 1)
                      ])
                    ]))
                  : (col.id === 'payment_method')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(row.payment_method), 1))
                    : (col.id === 'rental_fee')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, "₼ " + _toDisplayString(row.rental_fee.toFixed(2)), 1))
                      : (col.id === 'outstanding')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 3,
                            class: _normalizeClass(["outstanding-text", { debt: row.outstanding > 0 }])
                          }, " ₼ " + _toDisplayString(row.outstanding.toFixed(2)), 3))
                        : (col.id === 'deposit_status')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 4,
                              class: _normalizeClass(["deposit-badge", { released: row.deposit_status === 'RELEASED' }])
                            }, " ₼ " + _toDisplayString(row.deposit_amount.toFixed(2)) + " | " + _toDisplayString(row.deposit_status === 'RELEASED'
                    ? _ctx.$t('golf.financial.badge_released')
                    : row.deposit_status === 'HELD'
                    ? _ctx.$t('golf.financial.badge_held')
                    : `[${row.deposit_status}]`), 3))
                          : (col.id === 'timestamp')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(row.timestamp), 1))
                            : (col.id === 'action')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 6,
                                  href: "#",
                                  class: "view-details-link",
                                  onClick: _withModifiers(($event: any) => (viewDetails(row.id)), ["prevent"])
                                }, "View Details", 8, _hoisted_29))
                              : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["min-width", "prop", "align"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"])),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('golf.trips.showing_results', {
              start:
                filteredTransactions.value.length === 0
                  ? 0
                  : (currentPage.value - 1) * pageSize + 1,
              end: Math.min(
                currentPage.value * pageSize,
                filteredTransactions.value.length
              ),
              total: filteredTransactions.value.length,
            })), 1),
        _createVNode(_component_el_pagination, {
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((currentPage).value = $event)),
          total: filteredTransactions.value.length,
          "page-size": pageSize,
          layout: "prev, pager, next"
        }, null, 8, ["current-page", "total"])
      ])
    ])
  ]))
}
}

})